import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields } from 'better-auth/client/plugins';
import { auth } from './auth';
import { passkeyClient } from "@better-auth/passkey/client";
import { magicLinkClient, organizationClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  fetchOptions: {
      onError: async (context) => {
          const { response } = context;
          if (response.status === 429) {
              const retryAfter = response.headers.get("X-Retry-After");
              console.log(`Rate limit exceeded. Retry after ${retryAfter} seconds`);
          }
      },
  },
  plugins: [
    passkeyClient(),
    magicLinkClient(),
    organizationClient(),
    inferAdditionalFields<typeof auth>()
    ],
});

export const {
    signIn,
    signOut,
    signUp,
    useSession
} = authClient;